export enum GTMEcommerceItemStatus {
    Active = "aktywna",
    Archived = "archiwalna"
}
